export * from './isMobile';
export { default } from './isMobile';
//# sourceMappingURL=index.js.map